(function () {
  this.excludedCollections = [];

  this.filter_params = {
    product_loading_ele: '#filtz__product-loading-div',
    product_processing_ele: '#product-template',
    menu_loading_ele: '#filtz__filter-bar',
    pagination: {
      liquid_pagination_element: 'div#filtz__pagination-element',
      filtz_pagination_element: 'div#filtz__pagination-element',
      pagination_template: '#filtz__pagination-template',
    },
    exclude_price: true,
    products_per_page: 9,
    //products_per_page_element: "#filtz__product-per-page",
    toggle_class: 'clicked',
    sort_element: '#filtz__sort-by',
    menu_order: ['Product-Type', 'price', 'Type'],
    submenu_order: {
      Length: [50, 23, 45, 22],
    },
    ranges: {
      price: ['0-10', '10-25', '25-50', '50-100', '100-200', '200-350'],
      Dose: ['0-10', '10-25', '25-50', '50-@max_range'],
    },
    option_removals: ['size', 'price'],
    tag_removals: ['designtype', 'type'],
    submenu_removals: {
      Dose: [3, 10],
      Length: [23, 50],
    },
    get_filters_from_tags: true,
    get_filters_from_options: true,
    // show_vendor_as: "Brand",
    // show_product_type_as: "Pr Type",
    custom_headers: {
      Category: {
        header_name: 'Categories',
      },
    },
    menu: {
      parent_starting_html:
        '<div class="sidebar__filter-block filtzgroup" data-group="@header_name"><p class="filter-title"><strong>@header_name</strong></p>',
      //    '<div data-testing="1" class="filtzgroup @header_name" data-title="@header_name" title="@header_name" group="@header_count">',
      parent_ending_html: '</div>',
      submenu_starting_html: '<ul class="sidebar__filter-list">',
      submenu_ending_html: '</ul>',
      //submenu_html: '<li class="filtzoption"><a href="#">@menu_name</li></a>',
      submenu_html:
        '<li class="filtzoption"><div class="flex"><div class="flex-valign-center"><span class="control-indicator"></span><span class="control-label set-pointer">@menu_name</span></div><div class="flex-valign-center flex--ml-auto"><span class="control"> @count_placing</span></div><input type="checkbox" class="filter-checkbox"></div></li>',
      submenu_html_price:
        '<li class="filtzoption"><div class="flex"><div class="flex-valign-center"><span class="control-indicator"></span><span class="control-label set-pointer">$@menu_name</span></div><div class="flex-valign-center flex--ml-auto"><span class="control"> @count_placing</span></div><input type="checkbox" class="filter-checkbox"></div></li>',
    },

    show_count: '<span class="@count_class"></span>',
    clear_all_element: '#filtz__clear-all-button',
    active_filters: {
      container: '.active_filter_container',
      clear_all_ele: '.filtz__clearall-btns',
      filters_holder: '.tag-list',
      filter_element:
        '<li class="current-filter"><div class="tag">@filter_value<button type="button" aria-label="clear tag" class="clear-toggle filtz__clearall-btn"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close-small" viewBox="0 0 20 19"><g fill="none" fill-rule="evenodd"><g fill="#212325"><g><g><path d="M6.343.343c.552 0 1 .448 1 1v4h4c.552 0 1 .448 1 1s-.448 1-1 1h-4v4c0 .552-.448 1-1 1s-1-.448-1-1v-4h-4c-.552 0-1-.448-1-1s.448-1 1-1h4v-4c0-.552.448-1 1-1z" transform="translate(-178 -314) translate(80 312) rotate(45 50.964 131.625)"/></g></g></g></g></svg></button></div></li>',
      close_btn_class: 'current-filter',
    },
  };

  window.afterFilter = function (data) {
    let count = data.length;
    console.log('Filtering has done..');
    console.log('Process plugins like yopto etc....');
    $('.filters-toolbar__product-count').text(count + ' products');
  };

  window.afterFilterBarCreation = function () {
    console.log('Filter bar created');

    $(document).on('click', '.filter-title', function (e) {
      console.log('showing filter...');
      e.preventDefault();

      var currentList = $(this).next('ul');

      $(this).toggleClass('selected');
      // use position().top here as offset().top doesn't work in this case
      $(currentList).offset({ top: $(this).position().top + 55 });

      currentList.toggle();

      // ensure only one filter is displayed
      $('.filter-title').not($(this)).removeClass('selected');
      $('.sidebar__filter-list').not(currentList).hide();
    });

    // Close the open filter panel when the shopper clicks anywhere else on the
    // page (Warwick 2026-07-13: previously you had to click the exact filter
    // button again to dismiss it). Clicks on a filter button are handled above,
    // and clicks INSIDE the panel are ignored so ticking a checkbox does not
    // close it mid-selection. Same pattern as the .dd dropdown in custom.js.
    $(document).on('click.filtzOutside', function (e) {
      var $target = $(e.target);
      if ($target.closest('.filter-title').length) return;
      if ($target.closest('.sidebar__filter-list').length) return;

      $('.filter-title').removeClass('selected');
      $('.sidebar__filter-list').hide();
    });
    // console.log('Add view-more, view-less etc....');
    // viewMore();
    // $(document).on('click', '.view-more', function (e) {
    //   e.preventDefault();
    //   var thisClick = $(this);
    //   if (thisClick.text() == 'View More ') {
    //     thisClick.text('View Less ');
    //     thisClick
    //       .closest('.sidebar__filter-block')
    //       .find('.show-hide-group')
    //       .removeClass('hide');
    //   } else {
    //     thisClick.text('View More ');
    //     thisClick
    //       .closest('.sidebar__filter-block')
    //       .find('.show-hide-group')
    //       .addClass('hide');
    //   }
    // });
  };

  window.afterAppend = function (data) {
    console.log('Called when products are appended as tail');
  };
  this.viewMore = function () {
    // console.log('View more...');
    $('.filtzgroup').each(function () {
      var thisGroup = $(this);

      if (
        thisGroup.data('group') == 'Product-Type' &&
        window.location.pathname != '/collections/all-window-blinds-shades'
      ) {
        // don't display the product type (blinds vs. shades) filter unless we're viewing the top level collection
        thisGroup.hide();
      } else {
        if ($(this).find('.filtzoption').length > 7) {
          if ($(this).find('.view-more').length) {
          } else {
            thisGroup.append('<a href="" class="view-more">View More </a>');
          }
          var counterOption = 1;
          thisGroup.find('.filtzoption').each(function () {
            if (counterOption > 7) {
              $(this).addClass('show-hide-group');
              $(this).addClass('hide');
            }
            counterOption++;
          });
        }
      }
    });
  };
  /**
   * Set custom attributes for products (if any)
   */
  window.setProductData = function (data) {
    let item = data;

    item.img_id = 'ProductCardImage-' + sectionId + '-' + data.id;
    item.wrapper_id = 'ProductCardImageWrapper-' + sectionId + '-' + data.id;

    return item;
  };

  /**
   * ===========================
   * Handlebars helper functions
   * ===========================
   */

  /**
   * Set global liquid variables into handlebars
   * using object globalLiquidVariables
   */
  if (
    typeof globalLiquidVariables !== 'undefined' &&
    typeof globalLiquidVariables != null &&
    globalLiquidVariables != ''
  ) {
    Handlebars.registerHelper('globals', function (key) {
      console.log('Registering global ' + key);
      return globalLiquidVariables[key];
    });

    // Card USP bullets: show them only when the master switch is on AND this
    // product actually has bullets written. Keeping the same rule as the Liquid
    // card means the tile does not change the moment a shopper filters.
    Handlebars.registerHelper('showBullets', function (bullets) {
      if (globalLiquidVariables.show_bullets === false) return false;
      return Array.isArray(bullets) && bullets.length > 0;
    });
  }

  const reduceOp = function (args, reducer) {
    args = Array.from(args);
    args.pop(); // => options
    var first = args.shift();
    return args.reduce(reducer, first);
  };

  Handlebars.registerHelper({
    eq: function () {
      return reduceOp(arguments, (a, b) => a === b);
    },
    ne: function () {
      return reduceOp(arguments, (a, b) => a !== b);
    },
    lt: function () {
      return reduceOp(arguments, (a, b) => a < b);
    },
    gt: function () {
      return reduceOp(arguments, (a, b) => a > b);
    },
    lte: function () {
      return reduceOp(arguments, (a, b) => a <= b);
    },
    gte: function () {
      return reduceOp(arguments, (a, b) => a >= b);
    },
    and: function () {
      return reduceOp(arguments, (a, b) => a && b);
    },
    or: function () {
      return reduceOp(arguments, (a, b) => a || b);
    },
  });

  // Calculate save percentage for sale items
  Handlebars.registerHelper('savePercent', function (comparePrice, salePrice) {
    if (!comparePrice || !salePrice || comparePrice <= salePrice) {
      return 0;
    }
    const savings = ((comparePrice - salePrice) / comparePrice) * 100;
    return Math.round(savings);
  });

  Handlebars.registerHelper('stickerTags', function (tagStickers) {
    let badgeString = '';

    for (var m = 0; m < tagStickers.length; m++) {
      let tagVal = tagStickers[m].toLowerCase();
      if (tagVal.indexOf('featured') > -1) {
        badgeString +=
          '<span class="price__badge price__badge--featured"><span>FEATURED</span></span>';
        break;
      } else {
        badgeString +=
          '<span class="price__badge price__badge--sale" aria-hidden="true"><span>SALE</span></span>';
        badgeString +=
          '<span class="price__badge price__badge--sold-out" aria-hidden="true"><span>SOLD OUT</span></span>';
        badgeString +=
          '<span class="price__badge price__badge--new" aria-hidden="true"><span>NEW</span></span>';
        break;
      }
    }

    return badgeString;
  });
})();

(function () {
  this.devMode = false;

  function performanceLogger() {
    this.devMode = false;
    this.addEntry = function (name) {
      let self = this;

      if (self.devMode) {
        let funcName =
          arguments.length > 1 && typeof arguments[1] !== 'undefined'
            ? arguments[1]
            : name;
        let state =
          arguments.length > 2 && typeof arguments[2] !== 'undefined'
            ? arguments[2]
            : '';
        if (state != '') {
          state = state == 'start' ? ' started at ' : ' ended at ';
        }
        performance.mark(name);

        console.log(
          '## ' +
            funcName +
            state +
            ' at : ' +
            performance.getEntriesByName(name)[0].startTime,
        );
      }
    };

    this.measure = function (p1, p2, pName) {
      let self = this;

      if (self.devMode) {
        performance.measure(pName, p1, p2);
        let performanceDetails = performance.getEntriesByName(pName)[0];
        console.log(
          '# (Time) ' +
            pName +
            ' took ' +
            performanceDetails.duration +
            ' milliseconds to complete',
        );
      }
    };

    this.logInfo = function (log) {
      let self = this;

      if (self.devMode) {
        console.log('#-- ' + log);
      }
    };
  }

  window.PF = new performanceLogger();
  PF.logInfo('performanceLogger() [PF] initialized.');

  var domLoaded = false,
    jQueryLoaded = false,
    resultsLoaded = false;

  window.goAhead =
    resultCount <= 0 || _.indexOf(excludedCollections, resultHandle) !== -1
      ? false
      : true;
  this.productClass = 'flt__product-holder';
  this.parentClass = 'flt__parent-menu';
  this.childClass = 'flt__child-menu';
  this.parentKeyAttribute = 'flt__menu-key';
  this.parentNameAttribute = 'flt__menu-name';
  this.childKeyAttribute = 'flt__child-key';
  this.childNameAttribute = 'flt__child-name';
  this.baseToggleClass = 'flt__selected';
  this.filterClass = 'filtz__invoke-ele';
  this.countClass = 'filtz__count-ele';
  this.filterApplied = 0;
  this.currentDisplayedCount = 0;
  this.excludedUrlFilters = ['q', 'byfp'];

  PF.addEntry('process-start', 'Starting process.');

  // ============ Filter =========== //
  function filter() {
    this.filterData = function (data, params) {
      PF.addEntry('filter-start', 'Filtering data starts at');

      let filtered = _.filter(data, function (val, key) {
        let retVal = false;

        let productFilters = val.filters;
        let filterKeys = _.keys(productFilters);
        let parameterKeys = _.keys(params);
        let availableParameters = _.uniq(
          _.intersection(parameterKeys, filterKeys),
        );

        if (availableParameters.length >= parameterKeys.length) {
          let valueStatus = true;
          _.forEach(params, function (val_, key_) {
            let commonVals = _.uniq(_.intersection(val_, productFilters[key_]));
            if (commonVals.length == 0) {
              valueStatus = false;
            }
          });
          retVal = valueStatus;
        }
        return retVal;
      });

      PF.addEntry('filter-end', 'Filtered data ends at ');
      PF.measure('filter-start', 'filter-end', 'DataFiltering');

      return filtered;
    };

    this.sortData = function (sortParams, data) {
      let self = this;

      PF.addEntry('sort-start', 'Sorting data starts at');

      let sortObj = data;
      let prop = 'T';
      let mode = true;

      switch (sortParams) {
        case 'manual':
          prop = 'MNL';
          mode = 'asc';
          break;

        case 'best-selling':
          prop = 'BST';
          mode = 'asc';
          break;

        case 'price-ascending':
          prop = 'P';
          mode = 'asc';
          break;

        case 'price-descending':
          prop = 'P';
          mode = 'desc';
          break;

        case 'title-ascending':
          prop = 'T';
          mode = 'asc';
          break;

        case 'title-descending':
          prop = 'T';
          mode = 'desc';
          break;

        case 'created-descending':
          prop = 'CAT';
          mode = 'asc';
          break;

        case 'created-ascending':
          prop = 'CAT';
          mode = 'desc';
          break;

        default:
          prop = 'ORD';
          mode = 'asc';
          break;
      }

      PF.addEntry('sort-end', 'Sorted data at');
      PF.measure('sort-start', 'sort-end', 'DataSorting');

      return _.orderBy(sortObj, [prop, 'T'], [mode, 'asc']);
    };
  }

  if (goAhead) {
    window.F = new filter();
  }
  PF.logInfo('filter() initialized [F].');

  //=======================================//
  //=======================================//
  //=======================================//

  function emptyMenu() {
    const menuObject = {};
    menuObject.hasSubMenus = false;
    menuObject.orderNumber = 99999;
    menuObject.headerName = '';
    menuObject.headerKey = '';
    menuObject.subMenus = {};
    return menuObject;
  }

  function emptySubMenu() {
    const subMenuObject = {};
    subMenuObject.counter = 0;
    subMenuObject.orderNumber = 99999;
    subMenuObject.subMenuName = '';
    subMenuObject.subMenuKey = '';
    return subMenuObject;
  }

  function loadAndSetData() {
    let self = this;
    PF.logInfo('loadAndSetData() initialized [PF].');

    self.filterHolder = {};
    self.filterOrder = [];

    self.currentData = [];
    self.hasRanges =
      !_.isNil(filter_params) &&
      !_.isNil(filter_params.ranges) &&
      !_.isEmpty(filter_params.ranges)
        ? filter_params.ranges
        : false;
    self.menuOrder =
      !_.isNil(filter_params) &&
      !_.isNil(filter_params.menu_order) &&
      !_.isEmpty(filter_params.menu_order)
        ? filter_params.menu_order
        : false;
    self.subMenuOrder =
      !_.isNil(filter_params) &&
      !_.isNil(filter_params.submenu_order) &&
      !_.isEmpty(filter_params.submenu_order)
        ? filter_params.submenu_order
        : false;
    self.tagRemovals =
      !_.isNil(filter_params) &&
      !_.isNil(filter_params.tag_removals) &&
      !_.isEmpty(filter_params.tag_removals)
        ? filter_params.tag_removals
        : false;
    self.optionRemovals =
      !_.isNil(filter_params) &&
      !_.isNil(filter_params.option_removals) &&
      !_.isEmpty(filter_params.option_removals)
        ? filter_params.option_removals
        : false;
    self.subMenuRemovals =
      !_.isNil(filter_params) &&
      !_.isNil(filter_params.submenu_removals) &&
      !_.isEmpty(filter_params.submenu_removals)
        ? filter_params.submenu_removals
        : false;
    self.customHeaders =
      !_.isNil(filter_params) &&
      !_.isNil(filter_params.custom_headers) &&
      !_.isEmpty(filter_params.custom_headers)
        ? filter_params.custom_headers
        : false;
    self.takeVendor =
      !_.isNil(filter_params) &&
      !_.isNil(filter_params.show_vendor_as) &&
      !_.isEmpty(filter_params.show_vendor_as)
        ? filter_params.show_vendor_as
        : false;
    self.takeProductType =
      !_.isNil(filter_params) &&
      !_.isNil(filter_params.show_product_type_as) &&
      !_.isEmpty(filter_params.show_product_type_as)
        ? filter_params.show_product_type_as
        : false;
    self.takeTags =
      !_.isNil(filter_params) &&
      !_.isNil(filter_params.get_filters_from_tags) &&
      filter_params.get_filters_from_tags == true
        ? true
        : false;
    self.takeOptions =
      !_.isNil(filter_params) &&
      !_.isNil(filter_params.get_filters_from_options) &&
      filter_params.get_filters_from_options == true
        ? true
        : false;
    self.excludePrice =
      !_.isNil(filter_params) &&
      !_.isNil(filter_params.exclude_price) &&
      filter_params.exclude_price == true
        ? true
        : false;

    // if (templateName == "search") {
    //     if (!applyFILTzOnSearch) {
    //         removeFilterLoading();
    //         self.goAhead = false;
    //     }
    // } else if (templateName == "collection") {
    //     if (
    //         basicChecker(collectionsWithNoFilters) &&
    //         collectionsWithNoFilters.length > 0
    //     ) {
    //         if (collectionsWithNoFilters.indexOf(resultHandle) === -1) {
    //             removeFilterLoading();
    //             self.goAhead = false;
    //         }
    //     }
    // }

    // if (self.goAhead) {
    //     self.initiateProcess();
    // }
  }

  let P1 = loadAndSetData.prototype;

  if (goAhead) {
    window.LSD = new loadAndSetData();
  }

  P1.createFilterObject = function (key) {
    let self = this;

    // PF.addEntry("create-filterobj-start", "Creating filter object");

    let orderNum =
      arguments.length > 0 &&
      !_.isUndefined(arguments[1]) &&
      parseInt(arguments[1]) >= 0
        ? parseInt(arguments[1])
        : 99999;
    let menuObj = new emptyMenu();
    _.set(menuObj, 'headerKey', key);
    _.set(menuObj, 'headerName', key);
    let hasCustomHeaders =
      self.customHeaders && _.hasIn(self.customHeaders, key)
        ? self.customHeaders[key]
        : false;
    if (hasCustomHeaders && _.hasIn(hasCustomHeaders, 'header_name')) {
      _.set(menuObj, 'headerName', hasCustomHeaders.header_name);
    }
    if (orderNum >= 0) {
      _.set(menuObj, 'orderNumber', orderNum);
    }

    let subMenus = {};
    let subMenuOrder = self.getSubmenuOrder(key);
    if (subMenuOrder) {
      _.forEach(subMenuOrder, function (val, k) {
        let pushStatus =
          self.subMenuRemovals &&
          _.hasIn(self.subMenuRemovals, key) &&
          _.indexOf(self.subMenuRemovals[key], val) !== -1
            ? false
            : true;
        if (pushStatus) {
          let subMenuObj = new emptySubMenu();
          let subMenuName =
            hasCustomHeaders &&
            _.hasIn(hasCustomHeaders, 'sub_menus') &&
            _.hasIn(hasCustomHeaders.sub_menus, val)
              ? hasCustomHeaders.sub_menus[val]
              : val;
          let subMenuKey = val;
          subMenuObj.subMenuName = subMenuName;
          subMenuObj.subMenuKey = subMenuKey;
          subMenuObj.orderNumber = k;
          _.set(subMenus, subMenuKey, subMenuObj);
        }
      });
      _.set(menuObj, 'subMenus', subMenus);
    }

    //   PF.addEntry("create-filterobj-end", "Created filter object");
    //   PF.measure(
    //     "create-filterobj-start",
    //     "create-filterobj-end",
    //     "FilterObjectCreation"
    //   );

    return menuObj;
  };

  P1.getSubmenuOrder = function (key) {
    let self = this;

    //   PF.addEntry("get-submenu-order-start", "Getting submenu order");

    let order =
      self.hasRanges && _.hasIn(self.hasRanges, key)
        ? self.hasRanges[key]
        : false;
    if (!order) {
      order =
        self.subMenuOrder && _.hasIn(self.subMenuOrder, key)
          ? self.subMenuOrder[key]
          : false;
    }

    //   PF.addEntry("get-submenu-order-end", "Got submenu order");
    //   PF.measure(
    //     "get-submenu-order-start",
    //     "get-submenu-order-end",
    //     "GetSubMenuOrder"
    //   );

    return order;
  };

  P1.setFilterHolder = function () {
    let self = this;

    if (self.menuOrder) {
      _.forEach(self.menuOrder, function (value, key) {
        let status = true;
        if (value == 'price' && self.excludePrice == true) {
          status = false;
        }
        if (status) {
          let menuObj = self.createFilterObject(value, key);
          _.set(self.filterHolder, value, menuObj);
        }
      });
    }

    if (self.hasRanges) {
      _.forEach(self.hasRanges, function (value, key) {
        let status = true;
        if (key == 'price' && self.excludePrice == true) {
          status = false;
        }
        if (status) {
          if (!_.hasIn(self.filterHolder, key)) {
            let menuObj = self.createFilterObject(key);
            _.set(self.filterHolder, key, menuObj);
          }
        }
      });
    }

    if (self.takeVendor) {
      let menuObj = self.createFilterObject(self.takeVendor);
      _.set(self.filterHolder, self.takeVendor, menuObj);
    }

    if (self.takeProductType) {
      let menuObj = self.createFilterObject(self.takeProductType);
      _.set(self.filterHolder, self.takeProductType, menuObj);
    }
  };

  P1.setFilter = function (key, val) {
    let self = this;

    //   PF.addEntry("set-filter-start", "Set Filter Start");

    let retVal = new Object();
    retVal.key = key;
    retVal.val = val;
    let status = true;

    if (self.hasRanges && _.hasIn(self.hasRanges, key)) {
      let num = parseFloat(val);
      let range = false;
      let currentRanges = self.hasRanges[key];
      _.map(currentRanges, function (n) {
        let splittedNum = _.split(n, '-', 2);
        let fromValue =
          splittedNum[0] == '@max_range' ? 999999999999 : splittedNum[0];
        let toValue =
          splittedNum[1] == '@max_range' ? 999999999999 : splittedNum[1];
        if (_.inRange(num, fromValue, toValue)) {
          retVal.key = key;
          retVal.val = n;
        }
      });
    } else {
      if (self.subMenuRemovals && _.hasIn(self.subMenuRemovals, key)) {
        if (_.indexOf(self.subMenuRemovals[key], val) === -1) {
          status = true;
        }
      }
    }

    if (status) {
      let value = retVal.val;
      if (!_.hasIn(self.filterHolder, key)) {
        let menuObj = self.createFilterObject(key);
        _.set(self.filterHolder, key, menuObj);
      }
      _.set(self.filterHolder[key], 'hasSubMenus', true);

      let subMenus = _.get(self.filterHolder[key], 'subMenus');
      if (!_.hasIn(self.filterHolder[key].subMenus, value)) {
        let subMenuObj = new emptySubMenu();
        let subMenuName =
          self.customHeaders &&
          _.hasIn(self.customHeaders, key) &&
          _.hasIn(self.customHeaders[key], 'sub_menus') &&
          _.hasIn(self.customHeaders.sub_menus, value)
            ? self.customHeaders[key].sub_menus[value]
            : value;
        let subMenuKey = val;
        let orderNum =
          self.subMenuOrder &&
          _.hasIn(self.subMenuOrder, key) &&
          _.indexOf(self.subMenuOrder[key], value) !== -1
            ? _.indexOf(self.subMenuOrder[key], value)
            : 99999;
        subMenuObj.subMenuName = subMenuName;
        subMenuObj.subMenuKey = subMenuKey;
        subMenuObj.orderNumber = orderNum;
        _.set(self.filterHolder[key].subMenus, subMenuKey, subMenuObj);
      }

      let subMenuCounter =
        _.parseInt(_.get(self.filterHolder[key].subMenus[value], 'counter')) +
        1;
      _.set(self.filterHolder[key].subMenus[value], 'counter', subMenuCounter);

      //   PF.addEntry("set-filter-end", "Set Filter Ended");
      //   PF.measure("set-filter-start", "set-filter-end", "SetFilter");

      return retVal;
    } else {
      //   PF.addEntry("set-filter-end", "Set Filter Ended");
      //   PF.measure("set-filter-start", "set-filter-end", "SetFilter");

      return false;
    }
  };

  P1.setProductFilters = function (prod) {
    let self = this;

    PF.addEntry(
      'set-product-filters-start',
      'Setting product filters of ID:' + prod.id,
    );

    let filters = {};

    if (!self.excludePrice) {
      if (!_.hasIn(prod, 'P')) {
        throw new Error(
          'Price is not in valid format. Please provide price as P',
        );
      }
      _.set(filters, 'price', []);
      let filterObj = self.setFilter('price', _.divide(prod.P, 100));
      if (filterObj.val) {
        filters.price.push(filterObj.val);
      }
    }

    if (self.takeVendor) {
      if (!_.hasIn(prod, 'V')) {
        throw new Error(
          'Vendor is not in valid format. Please provide vendor as V',
        );
      }
      _.set(filters, self.takeVendor, []);
      let vendor = _.get(prod, 'V');
      let filterObj = self.setFilter(self.takeVendor, vendor);
      if (filterObj.val) {
        filters[self.takeVendor].push(filterObj.val);
      }
    }

    if (self.takeProductType) {
      if (!_.hasIn(prod, 'PT')) {
        throw new Error(
          'Product type is not in valid format. Please provide product_type as PT',
        );
      }
      _.set(filters, self.takeProductType, []);
      let productType = _.get(prod, 'PT');
      let filterObj = self.setFilter(self.takeProductType, productType);
      if (filterObj.val) {
        filters[self.takeProductType].push(filterObj.val);
      }
    }

    if (self.takeTags) {
      let tags = _.hasIn(prod, 'TG') && _.isArray(prod.TG) ? prod.TG : false;
      _.forEach(tags, function (tag) {
        if (_.includes(tag, ':')) {
          let tagArray = _.split(tag, ':');
          if (!_.isNil(tagArray[0]) && !_.isNil(tagArray[1])) {
            if (
              self.tagRemovals &&
              _.indexOf(self.tagRemovals, tagArray[0]) == -1
            ) {
              let tagKey = tagArray[0];
              let tagValue = tagArray[1];
              let filterObj = self.setFilter(tagKey, tagValue);
              if (filterObj.val) {
                if (!_.hasIn(filters, tagKey)) {
                  _.set(filters, tagKey, []);
                }
                if (_.indexOf(filters[tagKey], filterObj.val) == -1) {
                  filters[tagKey].push(filterObj.val);
                }
              }
            }
          }
        }
      });
    }
    if (self.takeOptions) {
      let options = _.hasIn(prod, 'O') && _.isArray(prod.O) ? prod.O : false;
      if (options) {
        _.forEach(options, function (option) {
          if (option.name != 'Title') {
            let optionKey = option.name;
            if (
              self.optionRemovals &&
              _.indexOf(self.optionRemovals, optionKey) == -1
            ) {
              _.forEach(option.values, function (opt) {
                if (opt != 'Default Title') {
                  let filterObj = self.setFilter(optionKey, opt);
                  if (filterObj.val) {
                    if (!_.hasIn(filters, optionKey)) {
                      _.set(filters, optionKey, []);
                    }
                    if (_.indexOf(filters[optionKey], filterObj.val) == -1) {
                      filters[optionKey].push(filterObj.val);
                    }
                  }
                }
              });
            }
          }
        });
      }
    }

    _.set(prod, 'filters', filters);

    PF.addEntry(
      'set-product-filters-end',
      'Set product filters of ID:' + prod.id,
    );
    PF.measure(
      'set-product-filters-start',
      'set-product-filters-end',
      'SetProductFilters(' + prod.id + ')',
    );
  };

  P1.getUrlTag = function () {
    let currentUrl = window.location.href;
    if (_.includes(currentUrl, '?')) {
      currentUrl = currentUrl.substring(0, currentUrl.indexOf('?'));
    }
    let urlArray = _.split(currentUrl, '/collections/');
    let trimmedArray = _.split(urlArray[1], '/');
    return typeof trimmedArray[1] !== 'undefined' &&
      typeof trimmedArray[1] !== null &&
      trimmedArray[1] != ''
      ? '/' + trimmedArray[1]
      : '';
  };

  P1.initiateProcess = function () {
    let self = this;

    if (
      basicChecker(resultCount) &&
      basicChecker(paginateProductsBy) &&
      basicChecker(resultHandle) &&
      basicChecker(shopUrl)
    ) {
      self.countOfData = resultCount;
      self.paginateBy = paginateProductsBy;
      self.handle = resultHandle;
      self.shopUrl = shopUrl;
      self.urlTag = self.getUrlTag();
      if (templateName == 'collection') {
        self.collectionOrder = basicChecker(defaultOrder)
          ? defaultOrder
          : 'title-ascending';
      } else if (templateName == 'search') {
        self.collectionOrder = basicChecker(defaultOrder)
          ? defaultOrder
          : 'product';
      }

      self.noOfPages = Math.ceil(self.countOfData / self.paginateBy);
      if (templateName == 'collection') {
        self.urlString =
          self.shopUrl + '/collections/' + self.handle + self.urlTag;
        // if (self.subCollectionName) {
        //     self.urlString += "/" + self.subCollectionName;
        // }
      } else if (templateName == 'search') {
        self.urlString =
          self.shopUrl +
          '/search?q=' +
          self.handle +
          '&options[prefix]=last&type=' +
          self.collectionOrder +
          '&view=json';
      }

      console.log('self ', self);

      self.productData = {};
      self.totalCounter = self.countOfData;
      self.manualCounter = 0;
      self.bestSellingCounter = 0;
      self.usualCounter = 0;

      if (self.noOfPages <= 0) {
        // removeFilterLoading();
        console.log('Operation terminated due to zero results');
      } else {
        self.initiateAjax();
      }
      self.setFilterHolder();
    }
  };

  P1.convergeData = function () {
    let self = this;
    PF.addEntry('ajax-end', 'Ajax Ended');
    PF.measure('ajax-start', 'ajax-end', 'Ajax');

    self.productData = F.sortData(
      self.collectionOrder,
      _.toArray(self.productData),
    );
    resultsLoaded = true;
    stateChecker();
    D.data = self.productData;
    D.currentData = self.productData;
    D.createSideMenu(self.filterHolder);
  };

  P1.processResults = function (data, appendTo, pageNum) {
    let self = this;
    let parsedData = JSON.parse(data);
    if (basicChecker(parsedData)) {
      let pageIndex = _.toNumber(pageNum) - 1;
      let orderNum = 0;
      if (pageIndex > 0) {
        orderNum = _.toNumber(pageIndex * self.paginateBy);
      }
      _.forEach(parsedData, function (prod, index) {
        orderNum++;
        let prodId = prod.id;

        if (!_.has(self.productData, prodId)) {
          _.set(prod, 'ORD', 0);
          _.set(prod, 'BST', 0);
          _.set(prod, 'MNL', 0);

          self.setProductFilters(prod);
          _.set(self.productData, prodId, prod);
        }
        if (appendTo == 'manual') {
          _.set(self.productData, [prodId, 'MNL'], orderNum);
          self.manualCounter++;
        } else if (appendTo == 'best-selling') {
          _.set(self.productData, [prodId, 'BST'], orderNum);
          self.bestSellingCounter++;
        }
        if (appendTo == defaultOrder) {
          _.set(self.productData, [prodId, 'ORD'], orderNum);
          self.usualCounter++;
        }
        if (index == parsedData.length - 1) {
          if (
            self.totalCounter == self.manualCounter &&
            self.totalCounter == self.bestSellingCounter &&
            self.totalCounter == self.usualCounter
          ) {
            self.convergeData();
          }
        } else if (parsedData.length == 0) {
          // removeFilterLoading();
        }
      });
    }
  };

  P1.processSearchResults = function (data, pageNum) {
    let self = this;

    let parsedData = JSON.parse(data);
    if (basicChecker(parsedData)) {
      let pageIndex = _.toNumber(pageNum) - 1;
      let orderNum = 0;
      if (pageIndex > 0) {
        orderNum = _.toNumber(pageIndex * self.paginateBy);
      }

      _.forEach(parsedData, function (prod, index) {
        orderNum++;
        let prodId = prod.id;
        if (!_.has(self.productData, prodId)) {
          self.setProductFilters(prod);
          _.set(self.productData, prodId, prod);
          self.usualCounter++;
        }
        if (index == parsedData.length - 1) {
          if (self.totalCounter == self.usualCounter) {
            self.convergeData();
          }
        }
      });
    }
  };

  P1.dataRetriever = function (pageUrl, appendTo, pageNum) {
    let self = this;

    let xhr = new XMLHttpRequest();
    xhr.open('GET', pageUrl);
    xhr.setRequestHeader('Content-Type', 'text/html; charset=utf-8');
    xhr.send();

    xhr.onload = function () {
      if (xhr.status != 200) {
        throw new Error('Error ' + xhr.status + ':' + xhr.statusText);
      } else {
        if (appendTo == 'search') {
          self.processSearchResults(xhr.responseText, pageNum);
        } else {
          self.processResults(xhr.responseText, appendTo, pageNum);
        }
      }
    };

    xhr.onerror = function () {
      throw new Error('FILTz error : Unable to complete Ajax Request');
    };
  };

  P1.initiateAjax = function () {
    let self = this;

    PF.addEntry('ajax-start', 'Ajax Started');

    const arr = Array.from({ length: self.noOfPages }, (_, index) => index + 1);

    _.forEach(arr, function (m) {
      if (templateName == 'collection') {
        /**
         * Get data in best-selling order
         */
        let ajaxUl =
          self.urlString + '?view=json&page=' + m + '&sort_by=best-selling';
        let appendTo = 'best-selling';
        self.dataRetriever(ajaxUl, appendTo, m);

        /**
         * Get data in manual order
         */
        ajaxUl = self.urlString + '?view=json&page=' + m + '&sort_by=manual';
        appendTo = 'manual';
        self.dataRetriever(ajaxUl, appendTo, m);

        /**
         * Get data in default order
         */
        if (
          self.collectionOrder != 'manual' &&
          self.collectionOrder != 'best-selling'
        ) {
          ajaxUl =
            self.urlString +
            '?view=json&page=' +
            m +
            '&sort_by=' +
            self.collectionOrder;
          appendTo = self.collectionOrder;
          self.dataRetriever(ajaxUl, appendTo, m);
        }
      } else if (templateName == 'search') {
        let ajaxUl = self.urlString + '&page=' + m;
        self.dataRetriever(ajaxUl, 'search', m);
      }
    });
  };

  if (goAhead) {
    LSD.initiateProcess();
  }

  function basicChecker(ele) {
    return !_.isNil(ele) && ele != '' ? true : false;
  }

  function stateChecker() {
    PF.logInfo('StateChecker() called ');
    PF.logInfo('DOMLoaded ' + domLoaded);
    PF.logInfo('jQueryLoaded ' + jQueryLoaded);
    PF.logInfo('ResultsLoaded ' + resultsLoaded);
    if (domLoaded && jQueryLoaded && resultsLoaded) {
      PF.logInfo('DOM, jQuery & Results are OK. So proceeding further...');
      F.data = LSD.productData;
    }
  }

  document.addEventListener('DOMContentLoaded', function (event) {
    jQueryLoaded = true;
    domLoaded = true;
    PF.addEntry('dom-ready', 'DOM ready');
    PF.addEntry('jquery-ready', 'jQuery ready');
    stateChecker();
  });
})();

(function ($, window, document, undefined) {
  function DOMEvents() {
    let self = this;

    PF.addEntry('dom-events-ready', 'DOMEvents() [D] ready');

    if (_.isNil(filter_params)) {
      throw new Error('filter_params is required. Please provide.');
    }

    self.data = [];
    self.currentData = [];
    self.mapper = {};
    self.parentKeyMap = {};
    self.parentNameMap = {};
    self.isPopState = false;
    self.selectedFilters = {
      sort: false,
      page: false,
      productsPerPage: false,
      filters: [],
      others: [],
    };
    self.currentSort = defaultOrder;

    self.activeFilterClass = 'selected-filter';
    self.activeFilterAttribute = 'filter-class';

    self.getEmptyMenu = function () {
      return {
        headerName: '',
        headerKey: '',
        decodedKey: '',
        decodedName: '',
        subMenus: [],
      };
    };

    self.getEmptySubMenu = function () {
      return {
        subMenuName: '',
        subMenuKey: '',
        decodedSubMenuKey: '',
        decodedSubMenuName: '',
        class: '',
        referenceClass: '',
      };
    };

    self.getMapperObject = function () {
      return {
        parentKey: '',
        parentName: '',
        decodedParentKey: '',
        decodedParentName: '',
        subMenuKey: '',
        subMenuName: '',
        decodedSubMenuKey: '',
        decodedSubMenuName: '',
        event: '',
      };
    };

    self.productLoadingEle =
      !_.isNil(filter_params.product_loading_ele) &&
      _.isString(filter_params.product_loading_ele)
        ? filter_params.product_loading_ele
        : false;

    if (!self.productLoadingEle) {
      throw new Error(
        "Please provide an element to load the products as 'product_loading_ele' in parameters.",
      );
    } else {
      if ($(self.productLoadingEle).length == 0) {
        throw new Error(
          'We are not able to find the ' + self.productLoadingEle + ' in DOM.',
        );
      }
    }

    self.productProcessingEle =
      !_.isNil(filter_params.product_processing_ele) &&
      _.isString(filter_params.product_processing_ele)
        ? filter_params.product_processing_ele
        : false;

    if (!self.productProcessingEle) {
      throw new Error(
        "Please provide an element to load the products as 'product_processing_ele' in parameters.",
      );
    } else {
      if ($(self.productProcessingEle).length == 0) {
        throw new Error(
          'We are not able to find the ' +
            self.productProcessingEle +
            ' in DOM.',
        );
      }
    }

    let source = $(self.productProcessingEle).html();
    self.productProcessingEle = Handlebars.compile(source);

    self.menuLoadingEle =
      !_.isNil(filter_params.menu_loading_ele) &&
      _.isString(filter_params.menu_loading_ele)
        ? filter_params.menu_loading_ele
        : false;

    if (!self.menuLoadingEle) {
      throw new Error(
        "Please provide an element to load the side-menu as 'menu_loading_ele' in parameters.",
      );
    } else {
      if ($(self.menuLoadingEle).length == 0) {
        throw new Error(
          'We are not able to find the ' + self.menuLoadingEle + ' in DOM.',
        );
      }
    }

    self.productsPerBatch =
      !_.isNil(filter_params.products_per_page) &&
      _.isNumber(filter_params.products_per_page) &&
      filter_params.products_per_page > 0
        ? filter_params.products_per_page
        : 10;

    self.toggleClass =
      !_.isNil(filter_params.toggle_class) &&
      _.isString(filter_params.toggle_class) &&
      filter_params.toggle_class != ''
        ? filter_params.toggle_class
        : '';

    self.hasSort =
      !_.isNil(filter_params.sort_element) &&
      _.isString(filter_params.sort_element) &&
      filter_params.sort_element != ''
        ? filter_params.sort_element
        : false;
    if (self.hasSort) {
      if ($(self.hasSort).length == 0) {
        throw new Error(
          'Cannot find the element for sorting (' + self.hasSort + ') in DOM.',
        );
      }
    }

    if (_.isNil(filter_params.menu)) {
      throw new Error('Please provide menu.');
    }
    if (!_.isObject(filter_params.menu)) {
      throw new Error('Please provide menu as an object.');
    }
    self.menu = filter_params.menu;

    if (_.isUndefined(self.menu.parent_starting_html)) {
      throw new Error('Please provide a "parent_starting_html" inisde menu.');
    }
    if (!_.isString(self.menu.parent_starting_html)) {
      throw new Error('"parent_starting_html" inisde menu must be a string.');
    }
    if (_.isUndefined(self.menu.parent_ending_html)) {
      throw new Error('Please provide a "parent_ending_html" inisde menu.');
    }
    if (!_.isString(self.menu.parent_ending_html)) {
      throw new Error('"parent_ending_html" inisde menu must be a string.');
    }
    if (_.isUndefined(self.menu.submenu_starting_html)) {
      throw new Error('Please provide a "submenu_starting_html" inisde menu.');
    }
    if (!_.isString(self.menu.submenu_starting_html)) {
      throw new Error('"submenu_starting_html" inisde menu must be a string.');
    }
    if (_.isUndefined(self.menu.submenu_ending_html)) {
      throw new Error('Please provide a "submenu_ending_html" inisde menu.');
    }
    if (!_.isString(self.menu.submenu_ending_html)) {
      throw new Error('"submenu_ending_html" inisde menu must be a string.');
    }
    if (_.isUndefined(self.menu.submenu_ending_html)) {
      throw new Error('Please provide a "submenu_ending_html" inisde menu.');
    }
    if (!_.isString(self.menu.submenu_ending_html)) {
      throw new Error('"submenu_ending_html" inisde menu must be a string.');
    }
    if (_.isUndefined(self.menu.submenu_html)) {
      throw new Error('Please provide a "submenu_html" inisde menu.');
    }
    if (!_.isString(self.menu.submenu_html)) {
      throw new Error('"submenu_html" inisde menu must be a string.');
    }

    self.customMenu =
      !_.isNil(filter_params.custom_menu) &&
      _.isObject(filter_params.custom_menu)
        ? filter_params.custom_menu
        : false;

    self.showCount =
      !_.isNil(filter_params.show_count) && _.isString(filter_params.show_count)
        ? filter_params.show_count
        : false;

    self.clearAllElement =
      !_.isNil(filter_params.clear_all_element) &&
      _.isString(filter_params.clear_all_element)
        ? filter_params.clear_all_element
        : false;
    if (self.clearAllElement) {
      if ($(self.clearAllElement).length == 0) {
        throw new Error(
          'Cannot find the element for clearing all filters (' +
            self.clearAllElement +
            ') in DOM.',
        );
      }
    }

    if (
      _.hasIn(filter_params, 'active_filters') &&
      _.isObject(filter_params.active_filters) &&
      !_.isEmpty(filter_params.active_filters)
    ) {
      let active_filters = filter_params.active_filters;

      if (!_.hasIn(active_filters, 'container')) {
        throw new Error(
          "Cannot find 'container' inside active_filters in filter_params.",
        );
      } else {
        if ($(active_filters.container).length == 0) {
          throw new Error(
            'Cannot find the element for showing active/selected filters (' +
              active_filters.container +
              ') in DOM.',
          );
        }
      }

      if (!_.hasIn(active_filters, 'filters_holder')) {
        throw new Error(
          "Cannot find 'filters_holder' inside active_filters in filter_params.",
        );
      } else {
        if ($(active_filters.filters_holder).length == 0) {
          throw new Error(
            'Cannot find the element for appending active/selected filters (' +
              active_filters.filters_holder +
              ') in DOM.',
          );
        }
      }

      if (!_.hasIn(active_filters, 'filter_element')) {
        throw new Error(
          "Cannot find 'filter_element' inside active_filters in filter_params.",
        );
      }

      self.activeFilters = {
        container: active_filters.container,
        filtersHolder: active_filters.filters_holder,
        filterElement: active_filters.filter_element,
      };

      if (
        _.hasIn(active_filters, 'clear_all_ele') &&
        _.isString(active_filters.clear_all_ele)
      ) {
        _.set(
          self.activeFilters,
          'clearAllElement',
          active_filters.clear_all_ele,
        );
      }

      if (
        _.hasIn(active_filters, 'close_btn_class') &&
        _.isString(active_filters.close_btn_class)
      ) {
        _.set(
          self.activeFilters,
          'filterCloseClass',
          active_filters.close_btn_class,
        );
      }
    } else {
      self.activeFilters = false;
    }

    self.bindLoadMore = function () {
      $(window).bind(
        'scroll',
        _.debounce(function (e) {
          if (
            $(window).scrollTop() >=
            $(self.productLoadingEle).offset().top +
              $(self.productLoadingEle).outerHeight() -
              window.innerHeight
          ) {
            self.appendProducts();
          }
        }, 150),
      );
    };

    self.bindPagination = function () {
      let self = this;

      if (!_.hasIn(filter_params.pagination, 'liquid_pagination_element')) {
        throw new Error(
          "Cannot find the 'liquid_pagination_element' for showing/hiding the liquid pagination in filter_params.",
        );
      } else {
        if ($(filter_params.pagination.liquid_pagination_element).length == 0) {
          throw new Error(
            'We are not able to find the ' +
              filter_params.pagination.liquid_pagination_element +
              ' in DOM.',
          );
        }
      }

      if (!_.hasIn(filter_params.pagination, 'filtz_pagination_element')) {
        throw new Error(
          "Cannot find the 'filtz_pagination_element' for showing filtz pagination in filter_params.",
        );
      } else {
        if ($(filter_params.pagination.filtz_pagination_element).length == 0) {
          throw new Error(
            'We are not able to find the ' +
              filter_params.pagination.filtz_pagination_element +
              ' in DOM.',
          );
        }
      }

      if (!_.hasIn(filter_params.pagination, 'pagination_template')) {
        throw new Error(
          "Cannot find the 'pagination_template' for showing pagination in filter_params.",
        );
      } else {
        if ($(filter_params.pagination.pagination_template).length == 0) {
          throw new Error(
            'We are not able to find the ' +
              filter_params.pagination.pagination_template +
              ' in DOM.',
          );
        }
      }

      self.pagination = {
        page: 1,
        liquidPaginationEle: filter_params.pagination.liquid_pagination_element,
        filtzPaginationEle: filter_params.pagination.filtz_pagination_element,
        displayedData: [],
        totalPages: 0,
        linkCount: 5,
        productsPerPage: self.productsPerBatch,
        template: Handlebars.compile(
          $(filter_params.pagination.pagination_template).html(),
        ),
      };

      self.pagination.productsPerPageElement = _.hasIn(
        filter_params,
        'products_per_page_element',
      )
        ? filter_params.products_per_page_element
        : false;

      if (self.pagination.productsPerPageElement) {
        if ($(self.pagination.productsPerPageElement).length == 0) {
          throw new Error(
            'We are not able to find the ' +
              self.pagination.productsPerPageElement +
              ' in DOM.',
          );
        }
      }

      $(self.pagination.filtzPaginationEle).on(
        'click',
        '[data-page]',
        function (e) {
          e.preventDefault();
          self.pageTriggered($(this).data('page'));
        },
      );

      if (self.pagination.productsPerPageElement) {
        $(self.pagination.productsPerPageElement).on('change', function (e) {
          e.preventDefault();
          if (!self.isPopState) {
            self.productsPerPageTriggered(_.parseInt($(this).val()));
          }
        });
      }
    };

    /**
     * Check if 'pagination' is provided as {}
     * If yes, pagination & products per page is considered
     * Else, we treat this as Ajax pagination
     * If pagination is OK,
     */
    self.hasPagination =
      !_.isNil(filter_params.pagination) && _.isObject(filter_params.pagination)
        ? true
        : false;

    if (self.hasPagination) {
      self.bindPagination();
    } else {
      self.bindLoadMore();
    }

    self.currentPage = self.hasPagination ? 1 : false;

    self.decode = function (str) {
      return _.toLower(decodeURIComponent(str)).split('_').join('-');
    };
  }

  let P3 = DOMEvents.prototype;
  if (goAhead) {
    this.D = new DOMEvents();
    PF.logInfo('DOMEvents() [D] initialized.');
  }

  P3.filterTriggered = function (isSelected, className) {
    let self = this;

    if (isSelected) {
      self.selectedFilters.filters.push(className);
    } else {
      _.pull(self.selectedFilters.filters, className);
    }

    /**
     * To update classes in filter-bar
     */
    self.updateFilterBar(isSelected, className);

    self.updateFilters('filters');
  };

  P3.sortTriggered = function () {
    let self = this;

    if (!self.isPopState) {
      self.selectedFilters.sort = $(self.hasSort).val();
      self.updateFilters('sort');
    }
  };

  P3.pageTriggered = function (page) {
    let self = this;

    self.pagination.page = page;
    self.selectedFilters.page = page;
    self.updateFilters('page');
  };

  P3.productsPerPageTriggered = function (num) {
    let self = this;

    self.pagination.productsPerPage = num;
    self.selectedFilters.productsPerPage = num;
    self.updateFilters('productsPerPage');
  };

  P3.popStateTriggered = function () {
    let self = this;

    self.updateFilters('popstate');
  };

  P3.checkUrlFilters = function () {
    let self = this;

    self.updateFilters('urlLoaded');
  };

  P3.updateFilters = function (event) {
    let self = this;

    PF.addEntry(
      'update-filter-start',
      'Checking Filters for (' + event + ') starts at',
    );

    let urlFilters = {};

    switch (event) {
      case 'urlLoaded':
        $.when(self.getFiltersFromUrl())
          .then(self.setFiltersFromUrl())
          .then(function () {
            let urlFilters = self.urlHolder;
            if (!_.isEmpty(urlFilters.others)) {
              otherUrlArray = [];
              _.forEach(urlFilters.others, function (val, key) {
                let otherUrl = key + '=' + val;
                if (_.indexOf(otherUrlArray, key) === -1) {
                  otherUrlArray.push(otherUrl);
                }
              });
              _.set(self.selectedFilters, 'others', otherUrlArray);
            }
            PF.logInfo('Filters from URL is ' + JSON.stringify(urlFilters));
            if (self.hasSort) {
              if (!urlFilters['sort-by']) {
                self.selectedFilters.sort = defaultOrder;
              } else {
                self.selectedFilters.sort = urlFilters['sort-by'];
              }
              if (self.selectedFilters.sort != $(self.hasSort).val()) {
                $(self.hasSort).val(self.selectedFilters.sort).change();
              }
            }
            if (self.hasPagination) {
              if (!urlFilters['page']) {
                self.selectedFilters.page = 1;
              } else {
                self.selectedFilters.page = urlFilters['page'];
              }
              if (self.pagination.page != self.selectedFilters.page) {
                self.pagination.page = self.selectedFilters.page;
              }
            }
            if (!_.isEmpty(urlFilters)) {
              $.when(self.createInitialFilter(urlFilters)).then(function () {
                if (filterApplied > 0) {
                  $.when(self.initiateFilter()).then(self.pushToHistory());
                }
              });
            }
          });
        break;

      case 'filters':
        filterApplied++;
        $.when(self.initiateFilter()).then(self.pushToHistory());
        break;

      case 'clearAllFilters':
        filterApplied++;
        $.when(self.initiateFilter()).then(self.pushToHistory());
        break;

      case 'sort':
        filterApplied++;
        $.when(self.initiateFilter()).then(self.pushToHistory());
        break;

      case 'page':
        filterApplied++;
        $.when(self.initiateFilter()).then(self.pushToHistory());
        break;

      case 'productsPerPage':
        filterApplied++;
        $.when(self.initiateFilter()).then(self.pushToHistory());
        break;

      case 'popstate':
        $.when(self.getFiltersFromUrl())
          .then(self.setFiltersFromUrl())
          .then(function () {
            let urlFilters = self.urlHolder;
            PF.logInfo('Filters from URL is ' + JSON.stringify(urlFilters));

            self.isPopState = true;
            let filterClasses = self.getClasses(urlFilters.filters);
            self.selectedFilters.filters = filterClasses;
            if (self.hasSort) {
              if (!urlFilters['sort-by']) {
                self.selectedFilters.sort = defaultOrder;
              } else {
                self.selectedFilters.sort = urlFilters['sort-by'];
              }
              if (self.selectedFilters.sort != $(self.hasSort).val()) {
                $(self.hasSort).val(self.selectedFilters.sort).change();
              }
            }
            if (self.hasPagination) {
              if (!urlFilters['page']) {
                self.selectedFilters.page = 1;
              } else {
                self.selectedFilters.page = urlFilters['page'];
              }
              if (self.pagination.page != self.selectedFilters.page) {
                self.pagination.page = self.selectedFilters.page;
              }
            }

            filterApplied++;
            $.when(self.initiateFilter())
              .then(self.updateFilterBar())
              .then(function () {
                self.isPopState = false;
              });
          });
        break;

      default:
        break;
    }

    PF.addEntry(
      'update-filter-end',
      'Checking Filters for (' + event + ') ends at',
    );
    PF.measure('update-filter-start', 'update-filter-end', 'Filtering');
  };

  P3.createInitialFilter = _.memoize(function (urlFilters) {
    let self = this;

    let hasFilter = false;
    console.log('-- createInitialFilter() --');
    if (!_.isEmpty(urlFilters.filters)) {
      _.forEach(urlFilters.filters, function (values, key) {
        _.forEach(values, function (v, k) {
          let className = self.getClassFromMapper(key, v);
          if (className) {
            console.log('className: ' + className);
            $('.' + className).addClass(
              baseToggleClass + ' ' + self.toggleClass,
            );
            $('.' + className).removeClass('fa fa-square');
            $('.' + className).addClass('fa fa-check-square');
            self.selectedFilters.filters.push(className);
            hasFilter = true;
          }
        });
      });
    }
    if (hasFilter) {
      filterApplied++;
    }
    console.log('-- createInitialFilter ended --');
  });

  P3.updateFilterBar = function () {
    let self = this;

    let isSelected =
      arguments.length > 0 && !_.isNil(arguments[0]) ? arguments[0] : false;
    let className =
      arguments.length > 1 && !_.isNil(arguments[1]) ? arguments[1] : false;

    if (className) {
      if (isSelected) {
        $('.' + className).addClass(baseToggleClass + ' ' + self.toggleClass);
        $('.' + className).removeClass('fa fa-square');
        $('.' + className).addClass('fa fa-check-square');
      } else {
        $('.' + className).removeClass(
          baseToggleClass + ' ' + self.toggleClass,
        );
        $('.' + className).removeClass('fa fa-check-square');
        $('.' + className).addClass('fa fa-square');
      }
    } else {
      _.forEach(self.mapper, function (val, key) {
        if (_.indexOf(self.selectedFilters.filters, key) === -1) {
          $('.' + key).removeClass(baseToggleClass + ' ' + self.toggleClass);
          $('.' + key).removeClass('fa fa-check-square');
          $('.' + key).addClass('fa fa-square');
        } else {
          $('.' + key).addClass(baseToggleClass + ' ' + self.toggleClass);
          $('.' + className).removeClass('fa fa-square');
          $('.' + className).addClass('fa fa-check-square');
        }
      });
    }
  };

  P3.bindEvents = function () {
    let self = this;

    PF.addEntry('binding-start', 'Started binding events at');

    _.forEach(self.mapper, function (value, key) {
      let $ele = $('.' + key);
      $('.' + key)
        .find('.filter-checkbox')
        .click(function () {
          let isSelected =
            _.indexOf(self.selectedFilters.filters, key) == -1 ? true : false;
          self.filterTriggered(isSelected, key);
        });
      // The option's text and box indicator toggle the filter too, so the whole
      // visible control is clickable, not just the checkbox input. Same handler
      // as above; the input sits outside these spans so a click never fires both.
      $('.' + key)
        .find('.control-label, .control-indicator')
        .click(function () {
          let isSelected =
            _.indexOf(self.selectedFilters.filters, key) == -1 ? true : false;
          // Tick the row's real checkbox to mirror what a native click on the
          // box does. Without this the filter applies but the box stays empty,
          // which reads as "nothing happened".
          $(this)
            .closest('.filtzoption')
            .find('.filter-checkbox')
            .prop('checked', isSelected);
          self.filterTriggered(isSelected, key);
        });
    });

    if (self.hasSort) {
      $(self.hasSort).change(function (event) {
        $(this).blur();
        self.sortTriggered();
      });
    }

    window.onpopstate = function (event) {
      self.popStateTriggered();
    };

    if (self.clearAllElement) {
      $(self.clearAllElement)
        .off('click')
        .on('click', function (e) {
          e.preventDefault();
          _.set(self.selectedFilters, 'filters', []);
          self.updateFilters('clearAllFilters');
        });
    }

    PF.addEntry('binding-end', 'Done binding events at ');
    PF.measure('binding-start', 'binding-end', 'BindingEvents');
  };

  P3.createFilterParams = function () {
    let self = this;

    let params = {};
    let currentFilters = _.get(self.selectedFilters, 'filters');

    _.forEach(currentFilters, function (className) {
      let credentials = _.get(self.mapper, className);

      if (!_.hasIn(params, credentials.parentKey)) {
        _.set(params, credentials.parentKey, []);
      }
      if (
        _.indexOf(params[credentials.parentKey], credentials.subMenuKey) == -1
      ) {
        params[credentials.parentKey].push(credentials.subMenuKey);
      } else {
      }
    });

    return params;
  };
  P3.initiateFilter = _.debounce(
    function () {
      let self = this;

      PF.addEntry('filtz-initiate', 'Filtz initiated at');

      if (filterApplied > 0) {
        let filterParams = self.createFilterParams();
        let products = _.isEmpty(filterParams)
          ? self.data
          : F.filterData(self.data, filterParams);

        // add GTM tracking for product impressions (safely check if function exists)
        if (typeof trackImpressions === 'function') {
          trackImpressions(products);
        }

        var sortText = {
          recommended: 'Featured',
          'best-selling': 'Best selling',
          'title-ascending': 'Alphabetically, A-Z',
          'title-descending': 'Alphabetically, Z-A',
          'price-ascending': 'Price, low to high',
          'price-descending': 'Price, high to low',
          'created-ascending': 'Date, old to new',
          'created-descending': 'Date, new to old',
        };

        if (self.hasSort && self.selectedFilters.sort) {
          let sortVal = self.selectedFilters.sort;
          if (!_.isNil(sortVal)) {
            sortText = sortText[sortVal];
            $(self.hasSortOption).text(sortText);
            products = F.sortData(sortVal, products);
          }
        }

        self.currentData = products;
        if (self.hasPagination) {
          console.log('--- Has Pagination ----');
          console.log('Current page - ' + self.currentPage);

          $.when(self.initPagination())
            .then(self.generateProductMarkup(self.pagination.displayedData))
            .then(self.setCount())
            .then(function () {
              if (self.activeFilters) {
                self.renderActiveFilters();
              }
            })
            .then(afterFilter(self.currentData));
        } else {
          let sliced = _.slice(
            self.currentData,
            currentDisplayedCount,
            currentDisplayedCount + self.productsPerBatch,
          );
          $.when(self.generateProductMarkup(sliced))
            .then(self.setCount())
            .then(function () {
              if (self.activeFilters) {
                self.renderActiveFilters();
              }
            })
            .then(afterFilter(self.currentData));
        }
      }

      PF.addEntry('filtz-conclude', 'FILTz applied at ');
      PF.measure('filtz-initiate', 'filtz-conclude', 'FILTzApplying');
    },
    250,
    { maxWait: 2000 },
  );

  P3.generateProductMarkup = function (data) {
    let self = this;

    PF.addEntry(
      'product-generation-start',
      'Product markup generation starts at',
    );

    try {
      let isAppend =
        arguments.length > 1 && arguments[1] == 'append' ? true : false;
      if (!isAppend) {
        $(self.productLoadingEle).empty();
        currentDisplayedCount = 0;
      }

      _.forEach(data, function (value) {
        let productHtml = self.productProcessingEle(value);
        $(self.productLoadingEle).append(productHtml);
        currentDisplayedCount++;
      });
      $(self.productLoadingEle).show();
      console.log('Displayed count -- ' + currentDisplayedCount);
    } catch (err) {
      console.log(' -------- ERROR ------- ', err);
    }

    PF.addEntry('product-generation-end', 'Products markup generated at ');
    PF.measure(
      'product-generation-start',
      'product-generation-end',
      'ProductGeneration',
    );
  };

  P3.appendProducts = function () {
    let self = this;

    PF.addEntry('append-start', 'Appending data at');
    PF.logInfo('Current products (displayed) : ' + currentDisplayedCount);
    PF.logInfo('Current products (all) : ' + self.currentData.length);

    let sliced = _.slice(
      self.currentData,
      currentDisplayedCount,
      currentDisplayedCount + self.productsPerBatch,
    );
    if (sliced.length > 0) {
      console.log('Calling generateProductMarkup 1 ');
      $.when(self.generateProductMarkup(sliced, 'append')).then(
        afterAppend(sliced),
      );
    }

    PF.addEntry('append-end', 'Appended data at ');
    PF.measure('append-start', 'append-end', 'AppendData');
  };

  P3.setCount = function () {
    let self = this;

    PF.addEntry('count-start', 'Starting to set count at');

    _.forEach(self.mapper, function (value, key) {
      let filterKey = value.parentKey;
      let filterValue = value.subMenuKey;
      let count = _.toInteger(
        _.size(
          _.filter(self.currentData, function (val, k) {
            return _.hasIn(val.filters, filterKey) &&
              _.indexOf(val.filters[filterKey], filterValue) !== -1
              ? true
              : false;
          }),
        ),
      );
      if (self.showCount) {
        let countText = parseInt(count) > 0 ? '(' + parseInt(count) + ')' : '';
        $('.' + key)
          .find('.' + countClass)
          .text(countText);
      }
    });

    PF.addEntry('count-end', 'Set count at ');
    PF.measure('count-start', 'count-end', 'SetCount');
  };

  P3.pushToHistory = function () {
    let self = this;

    let newUrl = self.createUrlString();
    PF.logInfo('New URL created at pushToHistory() - ' + newUrl);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    history.pushState({}, '', newUrl);
  };

  P3.getFiltersFromUrl = function () {
    var self = this;

    self.urlHolder = {
      filters: {},
      'sort-by': false,
      page: false,
      others: {},
      'products-per-page': false,
    };

    var pairs = document.location.search.replace('?', '').split('&');
    pairs = _.map(pairs, function (pair, index) {
      return pair.split('=');
    });

    _.forEach(pairs, function (pair, index) {
      if (
        typeof pair[0] !== 'undefined' &&
        _.isString(pair[0]) &&
        pair[0] != ''
      ) {
        var key = self.decode(pair[0]);
        if (_.indexOf(excludedUrlFilters, key) !== -1) {
          if (!_.hasIn(self.urlHolder.others, key)) {
            _.set(self.urlHolder.others, key, []);
          }
          if (
            typeof pair[1] !== 'undefined' &&
            _.isString(pair[1]) &&
            pair[1] != ''
          ) {
            var value = self.decode(pair[1]);
            if (_.indexOf(self.urlHolder.others[key], value) === -1) {
              self.urlHolder.others[key].push(value);
            }
          }
        } else if (key == 'sort-by') {
          if (
            typeof pair[1] !== 'undefined' &&
            _.isString(pair[1]) &&
            pair[1] != ''
          ) {
            var value = self.decode(pair[1]);
            self.urlHolder['sort-by'] = value;
          }
        } else if (key == 'page') {
          if (
            typeof pair[1] !== 'undefined' &&
            _.isString(pair[1]) &&
            pair[1] != ''
          ) {
            var value = parseInt(self.decode(pair[1]));
            self.urlHolder['page'] = value;
          }
        } else if (key == 'products-per-page') {
          if (
            typeof pair[1] !== 'undefined' &&
            _.isString(pair[1]) &&
            pair[1] != ''
          ) {
            var value = parseInt(self.decode(pair[1]));
            self.urlHolder['products-per-page'] = value;
          }
        } else {
          if (!_.hasIn(self.urlHolder.filters, key)) {
            _.set(self.urlHolder.filters, key, []);
          }
          if (
            typeof pair[1] !== 'undefined' &&
            _.isString(pair[1]) &&
            pair[1] != ''
          ) {
            var value = self.decode(pair[1]);
            if (_.indexOf(self.urlHolder.filters[key], value) === -1) {
              self.urlHolder.filters[key].push(value);
            }
          }
        }
      }
    });
  };

  P3.setFiltersFromUrl = function () {
    let self = this;
    let urlHolder = self.urlHolder;
    if (!_.isEmpty(urlHolder)) {
      _.forEach(urlHolder.filters, function (val, key) {
        if (
          !_.hasIn(self.parentKeyMap, key) &&
          !_.hasIn(self.parentNameMap, key)
        ) {
          _.unset(urlHolder.filters, key);
        } else {
          let availableValues = [];
          if (_.hasIn(self.parentNameMap, key)) {
            availableValues = _.keys(_.get(self.parentNameMap, key));
          } else if (_.hasIn(self.parentKeyMap, key)) {
            availableValues = _.keys(_.get(self.parentKeyMap, key));
          }

          let invalidValues = _.difference(val, availableValues);
          if (invalidValues.length > 0) {
            let updatedValues = _.pullAll(val, invalidValues);
            _.set(urlHolder.filters, key, updatedValues);
          }
        }
      });
    }
    self.urlHolder = urlHolder;
  };

  P3.createUrlString = function () {
    let self = this;
    let str = '';
    if (!_.isEmpty(self.selectedFilters.filters)) {
      let currentFilters = self.selectedFilters.filters;
      str = _.map(self.selectedFilters.filters, function (values, key) {
        let filterObj = _.get(self.mapper, values);
        return (
          encodeURIComponent(filterObj.decodedParentName) +
          '=' +
          encodeURIComponent(filterObj.decodedSubMenuName)
        );
      }).join('&');
    }

    if (self.hasSort && self.selectedFilters.sort) {
      str +=
        str == ''
          ? 'sort-by=' + self.selectedFilters.sort
          : '&sort-by=' + self.selectedFilters.sort;
    }

    if (self.hasPagination && self.selectedFilters.page) {
      str +=
        str == ''
          ? 'page=' + self.selectedFilters.page
          : '&page=' + self.selectedFilters.page;
    }

    if (
      self.pagination.productsPerPageElement &&
      self.selectedFilters.productsPerPage
    ) {
      str +=
        str == ''
          ? 'products-per-page=' + self.selectedFilters.productsPerPage
          : '&products-per-page=' + self.selectedFilters.productsPerPage;
    }

    if (self.selectedFilters.others.length > 0) {
      str +=
        str == ''
          ? self.selectedFilters.others.join('&')
          : '&' + self.selectedFilters.others.join('&');
    }

    return '?' + str;
  };

  P3.getClassFromMapper = function (header, sub) {
    let self = this;

    let className = false;

    _.forEach(self.mapper, function (n, key) {
      if (
        (header == n.decodedParentKey || header == n.decodedParentName) &&
        (sub == n.decodedSubMenuKey || sub == n.decodedSubMenuName)
      ) {
        className = key;
        return false;
      }
    });

    return className;
  };

  P3.getClasses = function (data) {
    let self = this;

    let classes = _.map(data, function (val, key) {
      let cls = [];
      if (_.hasIn(self.parentNameMap, key)) {
        cls = _.map(val, function (v, k) {
          let className = self.parentNameMap[key][v];
          return self.parentNameMap[key][v];
        });
      } else if (_.hasIn(self.parentKeyMap, key)) {
        cls = _.map(val, function (v, k) {
          let className = self.parentNameMap[key][v];
          return self.parentKeyMap[key][v];
        });
      }
      return !_.isEmpty(cls) ? cls : false;
    });

    return _.uniq(_.compact(_.flattenDeep(classes)));
  };

  P3.renderActiveFilters = function () {
    let self = this;

    PF.addEntry('active-filter-start', 'Starting to set active filters');
    $(self.activeFilters.filtersHolder).empty();
    if (_.isEmpty(self.selectedFilters.filters)) {
      $(self.activeFilters.container).hide();
    } else {
      let htmlString = '';
      _.forEach(self.selectedFilters.filters, function (val, key) {
        let filterDetails = _.get(self.mapper, val);
        let filterElement = self.activeFilters.filterElement;
        let htmlEle = self.stringReplace(
          filterElement,
          '@filter_header',
          filterDetails.parentName,
        );

        htmlEle = self.stringReplace(
          htmlEle,
          '@filter_value',
          filterDetails.subMenuName,
        );
        let $htmlEle = $(htmlEle);
        $htmlEle.addClass(self.activeFilterClass);
        $htmlEle.attr(self.activeFilterAttribute, val);

        htmlString += self.htmlToString($htmlEle);
      });

      if (htmlString !== '') {
        $(self.activeFilters.container)
          .show()
          .find(self.activeFilters.filtersHolder)
          .empty()
          .append(htmlString);

        /**
         * Binding events to close filters
         */
        if (_.hasIn(self.activeFilters, 'filterCloseClass')) {
          $(self.activeFilters.container)
            .off('click')
            .on(
              'click',
              '.' + self.activeFilters.filterCloseClass,
              function (e) {
                e.preventDefault();
                console.log('-- close button clicked --');
                let classAttribute = $(this)
                  .closest(self.activeFilterClass)
                  .attr(self.activeFilterAttribute);
                if (_.isUndefined(classAttribute)) {
                  classAttribute = $(this).attr(self.activeFilterAttribute);
                }
                $(self.menuLoadingEle)
                  .find('.' + classAttribute)
                  .find('.filter-checkbox')
                  .trigger('click');
              },
            );
        }
      }
    }

    if (self.activeFilters.clearAllElement) {
      $(self.activeFilters.clearAllElement)
        .off('click')
        .on('click', function (e) {
          e.preventDefault();
          _.set(self.selectedFilters, 'filters', []);
          self.updateFilters('clearAllFilters');
        });
    }
    PF.addEntry('active-filter-end', 'Active filters set at ');
    PF.measure('active-filter-start', 'active-filter-end', 'SetActiveFilter');
  };

  P3.htmlToString = function (htmlEle) {
    let self = this;

    let htmlStr = '';
    for (let m = 0; m < htmlEle.length; m++) {
      htmlStr += htmlEle[m]['outerHTML'];
    }
    return htmlStr;
  };

  P3.stringReplace = function (str, src, rep) {
    let self = this;

    if (_.isObject(str)) {
      str = JSON.stringify(str);
    }
    str = str.toString();
    str = str.split(src).join(rep);
    return str;
  };

  P3.getSideMenu = function (key) {
    let self = this;

    let menu = {
      parentStart: '',
      parentEnd: '',
      subMenuStart: '',
      subMenuEnd: '',
      subMenu: '',
    };
    if (self.customMenu && _.hasIn(self.customMenu, key)) {
      let customMenu = _.get(self.customMenu, key);
      menu.parentStart =
        _.hasIn(customMenu, 'parent_starting_html') &&
        _.isString(customMenu.parent_starting_html)
          ? customMenu.parent_starting_html
          : self.menu.parent_starting_html;
      menu.parentEnd =
        _.hasIn(customMenu, 'parent_ending_html') &&
        _.isString(customMenu.parent_ending_html)
          ? customMenu.parent_ending_html
          : self.menu.parent_ending_html;
      menu.subMenuStart =
        _.hasIn(customMenu, 'submenu_starting_html') &&
        _.isString(customMenu.submenu_starting_html)
          ? customMenu.submenu_starting_html
          : self.menu.submenu_starting_html;
      menu.subMenuEnd =
        _.hasIn(customMenu, 'submenu_ending_html') &&
        _.isString(customMenu.submenu_ending_html)
          ? customMenu.submenu_ending_html
          : self.menu.submenu_ending_html;
      menu.subMenu =
        _.hasIn(customMenu, 'submenu_html') &&
        _.isString(customMenu.submenu_html)
          ? customMenu.submenu_html
          : self.menu.submenu_html;
    } else {
      menu.parentStart = self.menu.parent_starting_html;
      menu.parentEnd = self.menu.parent_ending_html;
      menu.subMenuStart = self.menu.submenu_starting_html;
      menu.subMenuEnd = self.menu.submenu_ending_html;
      // TODO totally hacky
      menu.subMenu =
        key == 'price' ? self.menu.submenu_html_price : self.menu.submenu_html;
    }

    return menu;
  };

  /**
   * ======================
   * Pagination ***********
   * ======================
   */
  P3.initPagination = function () {
    let self = this;

    console.log('===== Init Pagination called ======');

    let paginated = self.getPaginatedData(
      self.currentData,
      self.pagination.page,
      self.pagination.productsPerPage,
    );
    console.log('Pagination count - ' + self.pagination.productsPerPage);
    console.log('Paginated data ', paginated);
    if (paginated.page > paginated.totalPages) {
      paginated.page = paginated.totalPages;
    }

    self.pagination.displayedData = paginated.data;
    self.pagination.page = paginated.page;
    self.pagination.totalPages = paginated.totalPages;

    if (self.pagination.totalPages > 1) {
      let links = self.createPaginationLinks();
      _.set(links, 'page', paginated.page);
      _.set(links, 'totalPages', paginated.totalPages);
      self.renderPaginationLinks(links);
    } else {
      $(filter_params.pagination.filtz_pagination_element).hide();
    }
  };

  P3.getPaginatedData = function (items, page, pageSize) {
    var pg = page || 1,
      pgSize = pageSize || 100,
      offset = (pg - 1) * pgSize,
      pagedItems = _.drop(items, offset).slice(0, pgSize);

    if (!pagedItems.length) {
      (pg = 1),
        (pgSize = pageSize || 100),
        (offset = (pg - 1) * pgSize),
        (pagedItems = _.drop(items, offset).slice(0, pgSize));
    }
    return {
      page: pg,
      pageSize: pgSize,
      total: items.length,
      totalPages: Math.ceil(items.length / pgSize),
      data: pagedItems,
    };
  };

  P3.createPaginationLinks = function () {
    let self = this;

    let currentPage = self.pagination.page;
    let totalPage = self.pagination.totalPages;
    let size = self.pagination.linkCount;

    let startPage, endPage, context, previousPage, nextPage;

    startPage = currentPage - Math.floor(size / 2);
    endPage = currentPage + Math.floor(size / 2);

    previousPage = currentPage <= 1 ? false : parseInt(currentPage) - 1;
    nextPage = currentPage >= totalPage ? false : parseInt(currentPage) + 1;

    if (startPage <= 0) {
      endPage -= startPage - 1;
      startPage = 1;
    }

    if (endPage > totalPage) {
      endPage = totalPage;
      if (endPage - size + 1 > 0) {
        startPage = endPage - size + 1;
      } else {
        startPage = 1;
      }
    }

    context = {
      startFromFirstPage: false,
      pages: [],
      endAtLastPage: false,
      nextPage: nextPage,
      previousPage: previousPage,
      lastDots: false,
      displayLastNumber: false,
    };

    if (startPage === 1) {
      context.startFromFirstPage = true;
    }
    if (endPage == totalPage - 1) {
      context.displayLastNumber = true;
    }
    if (endPage <= totalPage - 3) {
      context.lastDots = true;
    }

    for (let i = startPage; i <= endPage; i++) {
      context.pages.push({
        page: i,
        isCurrent: i === currentPage,
      });
    }

    if (endPage === totalPage) {
      context.endAtLastPage = true;
    }

    return context;
  };

  P3.renderPaginationLinks = function (links) {
    let self = this;

    let template = self.pagination.template;
    let paginationEle = template(links);

    $.when($(self.pagination.liquidPaginationEle).hide()).then(
      $(self.pagination.filtzPaginationEle)
        .show()
        .empty()
        .append(paginationEle),
    );
  };

  P3.createSideMenu = function (filters) {
    let self = this;

    if (devMode) {
      PF.addEntry('filter-bar-start', 'Started creating filter-bar at');
    }

    let orderedkeys = _.map(
      _.sortBy(filters, ['orderNumber', 'headerName']),
      'headerKey',
    );
    orderedkeys = _.compact(orderedkeys);
    let finalMenu = [];
    let classCounter = 1;

    $.when(
      _.forEach(orderedkeys, function (key) {
        let filter = _.get(filters, key);
        if (_.hasIn(filter, 'hasSubMenus') && filter.hasSubMenus) {
          let decodedParentKey = self.decode(key);
          let decodedParentName = self.decode(filter.headerName);

          let menuObj = self.getEmptyMenu();
          menuObj.headerName = filter.headerName;
          menuObj.headerKey = key;
          menuObj.decodedKey = decodedParentKey;
          menuObj.decodedName = decodedParentName;
          let orderedSubMenukeys = _.map(
            _.sortBy(filter.subMenus, ['orderNumber', 'subMenuName']),
            'subMenuKey',
          );
          orderedSubMenukeys = _.compact(orderedSubMenukeys);
          _.forEach(orderedSubMenukeys, function (subKey) {
            let subFilter = _.get(filter.subMenus, subKey);
            if (subFilter.counter > 0) {
              let encodedSubMenuKey = encodeURI(subKey);
              let decodedSubMenuKey = self.decode(encodedSubMenuKey);
              let encodedSubMenuName = encodeURI(subFilter.subMenuName);
              let decodedSubMenuName = self.decode(encodedSubMenuName);
              let referenceClass = 'filtz__ref-' + classCounter;
              classCounter++;

              let subMenuObj = self.getEmptySubMenu();
              subMenuObj.subMenuName = subFilter.subMenuName;
              subMenuObj.subMenuKey = subKey;
              subMenuObj.class = filterClass;
              subMenuObj.decodedSubMenuKey = decodedSubMenuKey;
              subMenuObj.decodedSubMenuName = decodedSubMenuName;
              subMenuObj.referenceClass = referenceClass;
              menuObj.subMenus.push(subMenuObj);

              if (!_.hasIn(self.mapper, subMenuObj.referenceClass)) {
                let mapperObj = self.getMapperObject();
                _.set(mapperObj, 'parentName', menuObj.headerName);
                _.set(mapperObj, 'parentKey', menuObj.headerKey);
                _.set(mapperObj, 'decodedParentKey', decodedParentKey);
                _.set(mapperObj, 'decodedParentName', decodedParentName);
                _.set(mapperObj, 'subMenuKey', subKey);
                _.set(mapperObj, 'subMenuName', subFilter.subMenuName);
                _.set(mapperObj, 'decodedSubMenuKey', decodedSubMenuKey);
                _.set(mapperObj, 'decodedSubMenuName', decodedSubMenuName);
                _.set(self.mapper, referenceClass, mapperObj);
              }

              if (!_.hasIn(self.parentKeyMap, decodedParentKey)) {
                _.set(self.parentKeyMap, decodedParentKey, {});
              }
              if (
                !_.hasIn(self.parentKeyMap[decodedParentKey], decodedSubMenuKey)
              ) {
                _.set(
                  self.parentKeyMap[decodedParentKey],
                  decodedSubMenuKey,
                  referenceClass,
                );
              }

              if (!_.hasIn(self.parentNameMap, decodedParentName)) {
                _.set(self.parentNameMap, decodedParentName, {});
              }
              if (
                !_.hasIn(
                  self.parentNameMap[decodedParentName],
                  decodedSubMenuName,
                )
              ) {
                _.set(
                  self.parentNameMap[decodedParentName],
                  decodedSubMenuName,
                  referenceClass,
                );
              }
            }
          });
          finalMenu.push(menuObj);
        }
      }),
    )
      .then(function () {
        $(self.menuLoadingEle).empty();
        let headerCount = 0;
        let menuCount = 0;
        if (self.showCount) {
          self.showCount = self.stringReplace(
            self.showCount,
            '@count_class',
            countClass,
          );
        }
        _.forEach(finalMenu, function (menu) {
          let htmlDetails = self.getSideMenu(menu.headerKey);

          headerCount++;
          let menuCountUnderHeader = 0;

          let parentStart = htmlDetails.parentStart;
          parentStart = self.stringReplace(
            parentStart,
            '@header_key',
            menu.headerKey,
          );
          parentStart = self.stringReplace(
            parentStart,
            '@header_name',
            menu.headerName,
          );
          parentStart = self.stringReplace(
            parentStart,
            '@header_count',
            parseInt(headerCount),
          );
          parentStart = self.stringReplace(
            parentStart,
            '@menu_count_under_header',
            parseInt(menuCountUnderHeader),
          );
          parentStart = self.stringReplace(
            parentStart,
            '@menu_count',
            parseInt(menuCount),
          );

          let parentEnd = htmlDetails.parentEnd;
          parentEnd = self.stringReplace(
            parentEnd,
            '@header_key',
            menu.headerKey,
          );
          parentEnd = self.stringReplace(
            parentEnd,
            '@header_name',
            menu.headerName,
          );
          parentEnd = self.stringReplace(
            parentEnd,
            '@header_count',
            parseInt(headerCount),
          );
          parentEnd = self.stringReplace(
            parentEnd,
            '@menu_count_under_header',
            parseInt(menuCountUnderHeader),
          );
          parentEnd = self.stringReplace(
            parentEnd,
            '@menu_count',
            parseInt(menuCount),
          );

          let subMenuStart = htmlDetails.subMenuStart;
          subMenuStart = self.stringReplace(
            subMenuStart,
            '@header_key',
            menu.headerKey,
          );
          subMenuStart = self.stringReplace(
            subMenuStart,
            '@header_name',
            menu.headerName,
          );
          subMenuStart = self.stringReplace(
            subMenuStart,
            '@header_count',
            parseInt(headerCount),
          );
          subMenuStart = self.stringReplace(
            subMenuStart,
            '@menu_count_under_header',
            parseInt(menuCountUnderHeader),
          );
          subMenuStart = self.stringReplace(
            subMenuStart,
            '@menu_count',
            parseInt(menuCount),
          );

          let subMenuEnd = htmlDetails.subMenuEnd;
          subMenuEnd = self.stringReplace(
            subMenuEnd,
            '@header_key',
            menu.headerKey,
          );
          subMenuEnd = self.stringReplace(
            subMenuEnd,
            '@header_name',
            menu.headerName,
          );
          subMenuEnd = self.stringReplace(
            subMenuEnd,
            '@header_count',
            parseInt(headerCount),
          );
          subMenuEnd = self.stringReplace(
            subMenuEnd,
            '@menu_count_under_header',
            parseInt(menuCountUnderHeader),
          );
          subMenuEnd = self.stringReplace(
            subMenuEnd,
            '@menu_count',
            parseInt(menuCount),
          );

          let subHtmls = '';
          _.forEach(menu.subMenus, function (value, key) {
            menuCount++;
            menuCountUnderHeader++;

            let subMenuHtml = htmlDetails.subMenu;
            subMenuHtml = self.stringReplace(
              subMenuHtml,
              '@header_key',
              menu.headerKey,
            );
            subMenuHtml = self.stringReplace(
              subMenuHtml,
              '@header_name',
              menu.headerName,
            );
            subMenuHtml = self.stringReplace(
              subMenuHtml,
              '@menu_key',
              value.subMenuKey,
            );
            subMenuHtml = self.stringReplace(
              subMenuHtml,
              '@menu_name',
              value.subMenuName,
            );
            subMenuHtml = self.stringReplace(
              subMenuHtml,
              '@header_count',
              parseInt(headerCount),
            );
            subMenuHtml = self.stringReplace(
              subMenuHtml,
              '@menu_count_under_header',
              parseInt(menuCountUnderHeader),
            );
            subMenuHtml = self.stringReplace(
              subMenuHtml,
              '@menu_count',
              parseInt(menuCount),
            );
            if (self.showCount) {
              subMenuHtml = self.stringReplace(
                subMenuHtml,
                '@count_placing',
                self.showCount,
              );
            } else {
              subMenuHtml = self.stringReplace(
                subMenuHtml,
                '@count_placing',
                '',
              );
            }

            let tempHtml = $(subMenuHtml);
            if (!tempHtml.hasClass(filterClass)) {
              tempHtml.addClass(filterClass);
            }
            if (!tempHtml.hasClass(value.referenceClass)) {
              tempHtml.addClass(value.referenceClass);
            }
            subHtmls += self.htmlToString(tempHtml);
          });

          let htmlString =
            parentStart + subMenuStart + subHtmls + subMenuEnd + parentEnd;
          let template = Handlebars.compile(htmlString);
          $(self.menuLoadingEle).append(template);
        });

        PF.addEntry('filter-bar-end', 'Filter-bar created at ');
        PF.measure('filter-bar-start', 'filter-bar-end', 'FilterBarGeneration');
      })
      .then(function () {
        self.bindEvents();
      })
      .then(function () {
        afterFilterBarCreation();
      })
      .then(function () {
        PF.logInfo('Going to set count for the filter-bar.');
        self.setCount();
      })
      .then(function () {
        PF.logInfo('Going to check filters from URL.');
        self.checkUrlFilters();
      })
      .then(function () {
        PF.addEntry('process-end', 'Ending process.');
        PF.measure('process-start', 'process-end', 'WholeProcess');
      });
  };
})(jQuery, window, document);
